<div *transloco="let t" class="p-10 flex flex-col gap-4">
  <div class="font-thin text-3xl">
    {{ t('cv.intro') }}
  </div>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ t('cv.yourQuotes') }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-accordion>
        @for (form of formQuotes.controls; track $index) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> {{ form.value.title || t('common.new') }}</mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <form class="flex gap-4" [formGroup]="form">
              <div class="flex items-center">
                @if (form.value.id) {
                  <wun-trash-icon (click)="deleteQuote(form.value.id!, $index)" class="scale-75"/>
                }
              </div>
              <div>
                <label>{{ t('common.title') }}</label>
                <input wunInput formControlName="title" type="text">
              </div>
              <div>
                <label>{{ t('common.technique') }}</label>
                <input wunInput formControlName="technique" type="text">
              </div>
              <div>
                <label>{{ t('common.quote') }}</label>
                <input wunInput formControlName="quote" type="number">
              </div>
              <div>
                <label>{{ t('common.height') }}</label>
                <input wunInput formControlName="height" type="number">
              </div>
              <div>
                <label>{{ t('common.width') }}</label>
                <input wunInput formControlName="width" type="number">
              </div>
            </form>
          </mat-expansion-panel>
        }

      </mat-accordion>

      <div class="flex gap-3 p-10">
        <button (click)="addNewQuote()" wunButton primary>{{ t('cv.addNew') }}</button>
        <button (click)="saveQuotes()" wunButton primary>{{ t('common.save') }}</button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ t('cv.yourGalleryParticipation') }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-accordion>
        @for (form of formParticipation.controls; track $index) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> {{ form.value.title || t('common.new') }}</mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <form class="flex gap-4" [formGroup]="form">
              <div class="flex items-center">
                @if (form.value.id) {
                  <wun-trash-icon (click)="deleteGallery(form.value.id!)" class="scale-75"/>
                }
              </div>
              <div>
                <label>{{ t('common.title') }}</label>
                <input wunInput formControlName="title" type="text">
              </div>
              <div>
                <label>{{ t('common.gallery') }}</label>
                <input wunInput formControlName="gallery" type="text">
              </div>
            </form>
          </mat-expansion-panel>
        }

      </mat-accordion>

      <div class="flex gap-3 p-10">
        <button (click)="addNewParticipation()" wunButton primary>{{ t('cv.addNew') }}</button>
        <button (click)="saveParticipation()" wunButton primary>{{ t('common.save') }}</button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>


